import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const paymentsModule = defineModule({
  name: "payments",
  label: "Payments",
  requires: ["core", "accounts", "configuration", "audit"],
  i18n: { en },
  // Admin step 13 (P5-03): transactions, refunds, reconciliation and gateway events. The storefront pays through
  // the store API (P4-06/P4-07).
  admin: {
    routes: [
      {
        path: "payments",
        permission: "payments.view_paymenttransaction",
        page: () => import("./admin/TransactionsPage"),
      },
      {
        path: "payments/refunds",
        permission: "payments.view_refund",
        page: () => import("./admin/RefundsPage"),
      },
      {
        path: "payments/reconciliation",
        permission: "payments.view_paymenttransaction",
        page: () => import("./admin/ReconciliationPage"),
      },
      {
        path: "payments/webhooks",
        permission: "payments.view_webhookevent",
        page: () => import("./admin/WebhooksPage"),
      },
    ],
    nav: [
      {
        id: "payments",
        group: "business",
        label: "payments:nav.payments",
        icon: "credit-card",
        to: "/payments",
        permission: "payments.view_paymenttransaction",
        order: 3,
      },
    ],
  },
  vendor: { routes: [], nav: [] },
});
